export default function SectionHeading({ eyebrow, title, children }) {
  return (
    <div className="mb-14 max-w-2xl">
      <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-[#CAA362]">
        {eyebrow}
      </p>
      <h2 className="font-serif-display text-3xl font-semibold leading-tight text-[#EAEBE7] sm:text-4xl">
        {title}
      </h2>
      {children && (
        <p className="mt-5 text-base leading-relaxed text-[#B5B8B0]">{children}</p>
      )}
    </div>
  );
}
